import { render } from "./Mijnwerker.vue?vue&type=template&id=392c65da&ts=true"
import script from "./Mijnwerker.ts?vue&type=script&lang=ts"
export * from "./Mijnwerker.ts?vue&type=script&lang=ts"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__